export const removeDuplicateIds = (volumes: any[]) => {
	return Array.from(new Set(volumes.map((v) => v.id))).map((id) => {
		return volumes.find((v) => v.id === id);
	});
};
